/**
 * Created by razial on 30.01.2023
 */

cc.ReplaceParent = function (parent) {
    cc.CallFunc.prototype.constructor.call(this, (target) => {
        target.replaceParentSamePlace(parent, {
            keepScale: true
        });
    });
};

cc.ReplaceParent.prototype = Object.assign(Object.create(cc.CallFunc.prototype), {
    constructor: cc.ReplaceParent
});